import styles from "./DesktopPane.module.scss";
import { Typography } from 'seagull';
import { Stepper } from "../Stepper";
import { relationshipModel } from "../../../../models";
import { useCobConfig } from "../../../clientOb/CobConfigContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DesktopPane = _ref => {
  let {
    stepperSteps,
    activeStepIndex,
    onStepClick,
    completedSteps,
    activeSteps,
    'data-testid': testid
  } = _ref;
  const {
    relationship
  } = useCobConfig();
  const vendorLogoUrl = relationshipModel.vendorLogoUrl({
    vendor: relationship.vendor
  });
  return /*#__PURE__*/_jsx("aside", {
    className: styles.root,
    "data-testid": testid,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.stepper,
      children: [vendorLogoUrl ? /*#__PURE__*/_jsx("div", {
        "data-testid": testid && "".concat(testid, "-logo"),
        className: styles.logoImg,
        style: {
          backgroundImage: "url(".concat(vendorLogoUrl, ")")
        }
      }) : /*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        className: styles.logoTxt,
        children: relationship.vendor.name
      }), /*#__PURE__*/_jsx(Stepper, {
        steps: stepperSteps,
        completedSteps: completedSteps || [],
        activeStepIndex: activeStepIndex,
        onStepClick: onStepClick,
        "data-testid": testid && testid + '-stepper',
        activeSteps: activeSteps || []
      })]
    })
  });
};